<template>
  <v-dialog v-model="show" max-width="600">
    <v-card class="pa-6">
      <v-card-title class="mb-5 text-h4 font-weight-medium"
        >Registrar cliente</v-card-title
      >
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="form.business_name"
                label="Nombre de la empresa"
                :rules="rules.required"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" v-if="canSelectVendor">
              <v-autocomplete
                v-model="form.vendor_user_id"
                :items="vendors"
                label="Seleccionar vendedor"
                item-text="display_name"
                item-value="id"
                :filter="customFilter"
                :rules="canSelectVendor ? rules.required : []"
                outlined
                clearable
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.display_name
                    }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="form.business_type"
                label="Figura jurídica"
                :items="[
                  { text: 'Persona física', value: 'person' },
                  { text: 'Persona moral', value: 'company' },
                ]"
                :rules="rules.businessTypeRequired"
                outlined
              ></v-select>
            </v-col>

            <v-col cols="6">
              <v-text-field
                v-model="form.contact_name"
                label="Nombre de contacto"
                :rules="rules.required"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="form.contact_phone"
                label="Teléfono de contacto"
                :rules="rules.phone"
                maxlength="10"
                prefix="+52"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="form.contact_email"
                label="Correo de contacto"
                :rules="rules.email"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <vuetify-money
                v-model="form.credit_requested"
                label="Línea de crédito deseada"
                valueWhenIsEmpty=""
                v-bind:options="options"
                outlined
              />
            </v-col>
            <v-col cols="6">
              <v-btn @click="show = false" outlined block> Cerrar </v-btn>
            </v-col>
            <v-col>
              <v-btn
                class="black white--text custom-disabled-btn"
                @click="handleSubmit"
                :disabled="!valid || inSubmit || !isFormValidWithVendor"
                outlined
                block
              >
                Confirmar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import options from "@/config/money";
import CustomerService from "@/services/customerService";
import SupplierService from "@/services/supplierService";

export default {
  props: ["visible"],
  data() {
    return {
      form: {
        business_name: null,
        contact_name: null,
        contact_phone: null,
        contact_email: null,
        credit_requested: null,
        business_type: null,
        vendor_user_id: null,
        origin: "frontdesk",
        continueRegistration: true,
      },
      vendors: [],
      canSelectVendor: false,
      inSubmit: false,
      valid: false,
      rules: {
        required: [(v) => !!v || "El campo es requerido"],
        email: [(v) => /.+@.+\..+/.test(v) || "Correo no válido"],
        phone: [
          (v) =>
            /^\d{10}$/.test(v) ||
            "El número debe incluir +52 y tener 10 dígitos.",
        ],
        businessTypeRequired: [
          (v) => v !== "" || "Debes seleccionar una figura jurídica",
        ],
      },
    };
  },

  mounted() {
    this.loadVendors();
  },

  methods: {
    async loadVendors() {
      try {
        this.canSelectVendor = await SupplierService.canSelectVendor();

        if (this.canSelectVendor) {
          const vendorsResponse = await SupplierService.getVendors();

          this.vendors = vendorsResponse.map((vendor) => ({
            id: vendor.id,
            display_name: `${vendor.code} - ${vendor.name}`,
            name: vendor.name,
            code: vendor.code,
          }));

          // Auto-populate vendor from localStorage if available
          const savedVendorId = localStorage.getItem(
            "mangxo_selected_vendor_user_id"
          );
          if (
            savedVendorId &&
            this.vendors.find((v) => v.id == savedVendorId)
          ) {
            this.form.vendor_user_id = parseInt(savedVendorId);
          }
        }
      } catch (error) {
        console.error("Error loading vendors:", error);
      }
    },

    customFilter(item, queryText) {
      const name = item.name || "";
      const code = item.code || "";
      const searchText = queryText.toLowerCase();

      return (
        name.toLowerCase().includes(searchText) ||
        code.toLowerCase().includes(searchText)
      );
    },
    async handleSubmit() {
      this.form.contact_phone = "52" + this.form.contact_phone;

      // Preparar payload - solo incluir vendor_user_id si canSelectVendor es true
      const payload = { ...this.form };
      if (!this.canSelectVendor) {
        delete payload.vendor_user_id;
      }

      const response = await CustomerService.createStep1(payload);
      const status = response.status;

      const data = {
        success: false,
        msg: "Ocurrio un error",
      };

      if (status == 200) {
        data.success = true;
        data.msg = "Cliente registrado";
      }

      this.reset();
      this.$emit("close");
      this.$emit("showDialogAlert", data);
    },
    reset() {
      (this.form.business_name = ""),
        (this.form.contact_name = ""),
        (this.form.business_type = ""),
        (this.form.contact_phone = ""),
        (this.form.contact_email = ""),
        (this.form.credit_requested = ""),
        (this.form.vendor_user_id = null),
        (this.form.origin = "frontdesk");
    },
  },

  watch: {
    "form.vendor_user_id"(newVal) {
      if (newVal) {
        localStorage.setItem("mangxo_selected_vendor_user_id", newVal);
      } else {
        localStorage.removeItem("mangxo_selected_vendor_user_id");
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    options: () => {
      return options;
    },
    isFormValidWithVendor() {
      const baseValidation =
        this.form.business_name &&
        this.form.contact_name &&
        this.form.contact_phone &&
        this.form.contact_email &&
        this.form.business_type;

      // Solo requerir vendor_user_id si canSelectVendor es true
      if (this.canSelectVendor) {
        return baseValidation && this.form.vendor_user_id;
      }

      return baseValidation;
    },
  },
};
</script>

<style>
.custom-disabled-btn.v-btn.v-btn--disabled {
  color: #fafafa !important; /* Cambia el color del texto a rojo cuando está deshabilitado */
  border-color: #fafafa !important; /* Opcional: cambia también el borde si es necesario */
  opacity: 1 !important; /* Evita que Vuetify aplique opacidad al botón deshabilitado */
  background-color: #ccc !important; /* Opcional: mantener fondo negro si es necesario */
}
</style>
